import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ClientServiceCreateResponseJson } from '@vmspdb/definitions';
import { Paginated } from '@vmspdb/ui/domain';
import * as fromPaginatedClient from './paginated-client.reducer';

export const selectPaginatedClientState =
  createFeatureSelector<fromPaginatedClient.PaginatedClientState>(
    fromPaginatedClient.paginatedClientFeatureKey,
  );

export const selectPaginatedClients = createSelector(
  selectPaginatedClientState,
  (state): Paginated<ClientServiceCreateResponseJson> => state,
);

export const selectPaginatedClientError = createSelector(
  selectPaginatedClientState,
  (state) => state.error,
);
